module.exports = {"id":"dp4_1l1q1","text":"Protecting Devices","instructions":"Who is primarily responsible for protecting the security of a personal digital device?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.1","questionType":"PickOne","random":true,"options":[{"id":"dp4_1l1q1-a1","text":"The device owner","score":1.8},{"id":"dp4_1l1q1-a2","text":"The device seller","score":0},{"id":"dp4_1l1q1-a3","text":"The internet provider","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.1/l1q1.json
// module id = 1202
// module chunks = 41